module.exports = __webpack_public_path__ + "UMB 2020 Health Disclosures.pdf";